import { FC } from 'react';
import { styled } from '../../../../../theme/stitches.config';
import { IKnockoutMobileProps } from './KnockoutMobile';

type IKnockoutRoundConnectingLineProps = Pick<IKnockoutMobileProps, 'hasSmallFinal'> & {
  idx: number;
  index: number;
  lastGroupNameIndex: number;
};

export const KnockoutRoundConnectingLine: FC<IKnockoutRoundConnectingLineProps> = ({ idx, index, lastGroupNameIndex, hasSmallFinal }) => {
  if ((index !== 0 && index < lastGroupNameIndex) || (lastGroupNameIndex === index && !hasSmallFinal)) {
    return <ConnectingLine style={{ top: '32px' }} />;
  }

  if (lastGroupNameIndex === index && hasSmallFinal && Math.abs(idx % 2) == 1) {
    return <ConnectingLine style={{ top: '-42px' }} />;
  }

  return null;
};

const ConnectingLine = styled.withConfig({ componentId: 'KnockoutRoundConnectingLine', displayName: 'ConnectingLine' })('div', {
  position: 'absolute',
  width: '16px',
  background: '$knockoutGameBorderColor',
  height: '1px',
  left: '-16px',
});
